import { IController } from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { ICourseDiff } from '../../../../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { IStudent } from '../../../../../../../../ng2/shared/typings/interfaces/student.interface';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class ProgramChangesExportStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'CsvExporter',
    'SpinnerModal',
    'CourseDiff',
    'WizardUtils',
    'ImCourseDiff',
  ];

  public currentTermYear;
  public starsInstructions;
  public uiReady: boolean = false;
  public studentsWithCreditGapPendingChanges: string[];
  public courseAdds: ICourseDiff[];
  public courseDrops: ICourseDiff[];
  private options;
  private allFlattenedStudents;
  private allUnflattenedStudents: IStudent[];
  private school;

  // bindings
  public selectedGradDate: string | null;
  public courseDiffs;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private CsvExporter,
    private SpinnerModal,
    private CourseDiff,
    private WizardUtils: WizardUtils,
    private imCourseDiff: ImCourseDiff,
    private ErrorModal,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.starsInstructions =
      'https://docs.google.com/document/d/1U3cKMJlpaXOOnGi5fZB2gZQa4XgukRnkCov1IIsM2qM/edit?usp=sharing';
    this.allFlattenedStudents = this.WizardUtils.getAllFlattenedStudents();
    this.allUnflattenedStudents = this.WizardUtils.getAllUnflattenedStudents();
    this.studentsWithCreditGapPendingChanges = this.getStudentIdsWithPendingGaps();
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.courseDiffs = this.getStudentsDiffs();
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    this.options = { sort: { colId: 'countOfCreditGapPendingChanges', sort: 'desc' } };
    const courseDiffFilter = {
      termYear: this.currentTermYear,
      status: 'PENDING',
    };
    this.courseAdds = this.imCourseDiff.filterForAddCourseDiffs(this.courseDiffs, courseDiffFilter);
    this.courseDrops = this.imCourseDiff.filterForDropCourseDiffs(this.courseDiffs, courseDiffFilter);
  }

  generateCourseDiffCsv(): void {
    const docType = 'text/csv;charset=utf-8';
    const termYear = this.currentTermYear;
    const currentDateAndTime = moment().format('MM-DD-YYYY hmma');
    const fileName = `STARS Course Upload ${termYear} ${currentDateAndTime}.csv`;
    this.SpinnerModal.activateSpinner('Generating Export');
    this.CsvExporter.createCourseDiffCsv(this.school)
      .then(csvString => {
        this.SpinnerModal.deactivateSpinner();
        this.CsvExporter.exportCsv(csvString, fileName, docType);
      })
      .catch(err => {
        this.SpinnerModal.deactivateSpinner();
        this.ErrorModal.show('Unable to complete CSV export', err);
      });
  }

  private getStudentDiffs(student: IStudent) {
    const pendingCourseDiffs = [];
    const found = _.find(this.allUnflattenedStudents, { studentId: student.studentId });
    const { join_pendingCourseDiffs } = found;
    if (join_pendingCourseDiffs.length > 0) {
      _.each(join_pendingCourseDiffs, (diff: ICourseDiff) => {
        if (diff.status !== 'DELETED') pendingCourseDiffs.push(diff);
      });
    }
    return pendingCourseDiffs;
  }

  private getStudentsDiffs() {
    const pendingCourseDiffs = [];
    _.each(this.allUnflattenedStudents, ({ join_pendingCourseDiffs }: IStudent) => {
      if (join_pendingCourseDiffs.length > 0) {
        _.each(join_pendingCourseDiffs, (diff: ICourseDiff) => {
          if (diff.status !== 'DELETED') pendingCourseDiffs.push(diff);
        });
      }
    });
    return pendingCourseDiffs;
  }

  private getStudentIdsWithPendingGaps(): string[] {
    return _.reduce(
      this.allFlattenedStudents,
      (result, student: any) => {
        const { studentId, countOfCreditGapPendingChanges } = student;
        const diffs = this.getStudentDiffs(student);
        if (countOfCreditGapPendingChanges > 0 || diffs.length > 0) {
          result.push(studentId);
        }
        return result;
      },
      [],
    );
  }
}
